/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShoppingCartDto } from '../../models/shopping-cart-dto';

export interface ShoppingCartControllerGet$Params {
}

export function shoppingCartControllerGet(http: HttpClient, rootUrl: string, params?: ShoppingCartControllerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ShoppingCartDto>> {
  const rb = new RequestBuilder(rootUrl, shoppingCartControllerGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShoppingCartDto>;
    })
  );
}

shoppingCartControllerGet.PATH = '/api/cart';
